export enum Group {
  REPORTS_1 = "report1-teleste-rmaportal-reports",
  REPORTS_2 = "report2-teleste-rmaportal-reports",
}

export enum Layout {
  TELESTE = "Teleste",
  TELESTE_INTERCEPT = "TelesteIntercept",
}